import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { localNow, parseDateTime, parseStringWithFormat } from '../../utils';
import { DateTime } from 'luxon';
import { _ti } from '@wephone-translation';

/**
 * Generated class for the DateInboxPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'dateInbox'
})
export class DateInboxPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args): any {
    const dateOnly: boolean = args && args[0] === 'dateOnly';
    if (value) {
      // today is first hour of this day
      let today = localNow();
      today = today.set({
        hour: 0,
        minute: 0,
        second: 0
      });
      const valJsDate = new Date(value);
      const val = DateTime.fromJSDate(valJsDate);
      const diff = today.diff(val, 'hour');
      let hour_diff: number = diff.hours;
      // today: show current time if option dateOnly is not marked
      if (hour_diff < 0) {
        if (!dateOnly) {
          hour_diff = today.diff(val, 'hour').hours;

          return val.toFormat('HH:mm'); // A
        }
        return _ti('dashboard.button.today');
      }
      // yesterday
      if (hour_diff < 24) {
        return _ti('dashboard.button.yesterday');
      }
      // on week
      if (hour_diff < 144) {
        // 24*6
        const day: number = val.weekday;

        return _ti(`day_of_week.${day}`);
      }

      return val.toISODate();
    }

    return value;
  }
}
